import { deploymentModels } from '../data';
import type { ModelId } from '../types';

const RolloutSection = ({ model }: { model: ModelId }) => {
  const current = deploymentModels[model];

  return (
    <section className="my-14">
      <h2 className="mb-1.5 text-3xl leading-[1.15] font-semibold tracking-tight">How the rollout works</h2>
      <p className="mb-6 max-w-[60ch] text-muted-foreground">{current.lede}</p>
      <ol>
        {current.steps.map((step, index) => (
          <li key={step.title} className="relative grid grid-cols-[56px_1fr] gap-[18px] pb-[26px] not-last:after:absolute not-last:after:top-10 not-last:after:bottom-0 not-last:after:left-[19px] not-last:after:w-0.5 not-last:after:bg-border">
            <span aria-hidden="true" className="z-10 grid size-10 place-items-center rounded-full border-2 border-(--deployment-accent) bg-card font-bold text-(--deployment-accent)">{index + 1}</span>
            <div>
              <h3 className="mt-1.5 mb-0.5 text-[19px] font-semibold">
                {step.title}
                {step.providedByHospital && (
                  <span className="ml-2 inline-block rounded-full bg-(--deployment-tint) px-2.5 py-px align-[2px] font-sans text-[13px] font-semibold text-(--deployment-accent)">Your IT team</span>
                )}
              </h3>
              <p className="max-w-[62ch] text-muted-foreground">{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default RolloutSection;
